<template>
  <div class="home">
    <homeView v-if="tagNav[1]" :list="list" :child="tagNav[1].child.slice(0,3)" />
    <homeView2 :list="tagLink"/>
    <footerView/>
    
    
  </div>
</template>

<script>
import homeView from '@/components/homeView.vue'
import homeView2 from '@/components/homeView2.vue'
import footerView from '@/components/footerView.vue'
import StudentsApi from "@/apis/service.js";
import { myMixins } from "@/utils/mixin.js";
import {mapState} from 'vuex'
export default {
  name: 'HomeView',
  mixins: [myMixins],
  data() {
    return {
      list: [],
      child:[], 
      tagLink:[]

    };
  },
  methods: {
    // handleSelect(key, keyPath) {
    //   console.log(key, keyPath);
    // }
  },
  components: {
    homeView,
    homeView2,
    footerView,
   
  },
  computed:{
    ...mapState([ 'tagNav'])
  },
  async created() {
    this.list = await StudentsApi.tagBanner();
    this.tagLink = await StudentsApi.tagLink();
    let obj = new Object
    obj.title = '希望之星'
    obj.keywords = '希望之星'
    obj.description = '希望之星'
    this.meta(obj)
    
  },
  // methods: {}
}
</script>
<style scoped lang="less">

</style>
